import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { Focusable, FocusableParent } from 'components/navigation';

const SECTION_NAME = 'CHANNEL_CATEGORIES';

const StyledCategoriesWrapper = styled(FocusableParent)`
  position: absolute;
  top: ${scaleSize(60)}px;
  left: ${scaleSize(140)}px;
`;

const StyledCategory = styled(Focusable)<{ isSelected: boolean }>`
  display: inline-block;
  box-sizing: border-box;
  font-family: 'RobotoRegular';
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(86)}px;
  height: ${scaleSize(86)}px;
  letter-spacing: -0.236111px;
  color: #f4f4f4;
  background: ${({ isSelected }) => (isSelected ? 'rgba(255, 255, 255, 0.05)' : 'none')};
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
  width: ${scaleSize(250)}px;
  margin-right: ${scaleSize(15)}px;
  border-radius: ${scaleSize(12)}px;
  border: solid ${scaleSize(2)}px transparent;

  &:focus {
    opacity: 1;
    border: solid ${scaleSize(2)}px ${({ theme }) => theme.activeColor};
  }
`;

interface ICategories {
  currentCategoryId: string;
  categories: { id: string; title: string }[];
  config: unknown;
  onEnter: (id: string) => void;
}

const Categories: React.FC<ICategories> = ({ categories, currentCategoryId, config, onEnter }) => {
  // TODO: upadte config on change
  return (
    <StyledCategoriesWrapper config={config} id={SECTION_NAME} sectionName={SECTION_NAME}>
      {categories.map(({ id, title }) => {
        const isSelected = id === currentCategoryId;
        return (
          <StyledCategory key={id} payload={id} onEnter={onEnter} id={id} isSelected={isSelected}>
            <span>{title}</span>
          </StyledCategory>
        );
      })}
    </StyledCategoriesWrapper>
  );
};

export default Categories;
